import { render } from "./AnomalyManagementView.vue?vue&type=template&id=5fe7dbf2&scoped=true"
import script from "./AnomalyManagementView.vue?vue&type=script&lang=js"
export * from "./AnomalyManagementView.vue?vue&type=script&lang=js"

import "./AnomalyManagementView.vue?vue&type=style&index=0&id=5fe7dbf2&scoped=true&lang=css"
import "./AnomalyManagementView.vue?vue&type=style&index=1&id=5fe7dbf2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe7dbf2"]])

export default __exports__